<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div class="dialog type-large">
        <header class="dialog-header">
          <h2 class="dialog-title only-pc">
            배송지 {{ isCreateMode ? "추가" : "수정" }}
          </h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">
              배송지 {{ isCreateMode ? "추가" : "수정" }}
            </h3>

            <form action="" class="table-form-wrap" @submit.prevent="submit">
              <div class="c-btn-area flex-ar">
                <button
                  type="button"
                  class="c-util-button type-line-black type-small"
                  @click="initForm"
                >
                  <span>초기화</span>
                </button>
              </div>

              <div class="c-table-form">
                <table>
                  <caption>
                    배송지 수정 폼
                  </caption>
                  <colgroup>
                    <col style="width: 120px" />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th scope="row" class="only-pc">
                        <div class="label">주소지 별칭<br />(최대 10자)</div>
                      </th>
                      <td>
                        <div class="label only-mo">
                          주소지 별칭<br />(최대 10자)
                        </div>
                        <div
                          class="c-form-field"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.dlvdesNm
                            ),
                          }"
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              maxlength="10"
                              title="주소지 별칭"
                              placeholder="주소지 별칭"
                              v-model="form.dlvdesNm"
                            />
                          </label>
                          <span
                            v-show="Utils.isNotBlank(validateMessages.dlvdesNm)"
                            class="input-valid"
                          >
                            {{ validateMessages.dlvdesNm }}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" class="only-pc">
                        <div class="label">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          받는 분<br />(최대 10자)
                        </div>
                      </th>
                      <td>
                        <div class="label only-mo">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          받는 분<br />(최대 10자)
                        </div>
                        <div
                          class="c-form-field"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.acptrNm
                            ),
                          }"
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              maxlength="10"
                              title="받는 분"
                              placeholder="받는 분"
                              v-model="form.acptrNm"
                            />
                          </label>
                          <span
                            v-show="Utils.isNotBlank(validateMessages.acptrNm)"
                            class="input-valid"
                          >
                            {{ validateMessages.acptrNm }}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" class="vct only-pc">
                        <div class="label">
                          <!-- <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span> -->
                          유선전화
                        </div>
                      </th>
                      <td>
                        <div class="label only-mo">
                          <!-- <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span> -->
                          유선전화
                        </div>
                        <div
                          class="c-form-field type-phone"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.acptrWrdTel
                            ),
                          }"
                        >
                          <div class="c-select">
                            <select v-model="form.acptrWrdTelno1">
                              <option value="">선택</option>
                              <option
                                v-for="number in wiredExcNumbers"
                                :key="number"
                                :value="number"
                              >
                                {{ number }}
                              </option>
                            </select>
                          </div>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="유선전화 중간 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="form.acptrWrdTelno2"
                            />
                          </label>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="유선전화 뒷 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="form.acptrWrdTelno3"
                            />
                          </label>
                          <!-- D: 유효성 검사 -->
                          <span
                            v-show="
                              !Utils.isBlank(validateMessages.acptrWrdTel)
                            "
                            class="input-valid"
                          >
                            {{ validateMessages.acptrWrdTel }}</span
                          >
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" class="vct only-pc">
                        <div class="label">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          휴대폰 번호
                        </div>
                      </th>
                      <td>
                        <div class="label only-mo">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          휴대폰 번호
                        </div>
                        <div
                          class="c-form-field type-phone"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.acptrMblTel
                            ),
                          }"
                        >
                          <div class="c-select">
                            <select v-model="form.acptrMblTelno1">
                              <option value="">선택</option>
                              <option
                                v-for="number in mobileExcNumbers"
                                :key="number"
                                :value="number"
                              >
                                {{ number }}
                              </option>
                            </select>
                          </div>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 중간 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="form.acptrMblTelno2"
                            />
                          </label>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 뒷 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="form.acptrMblTelno3"
                            />
                          </label>
                          <button
                            type="button"
                            class="c-button type-line-black type-small type-icon"
                            :disabled="extTelnosLength >= 1"
                            @click="addExtMblTelNo"
                          >
                            <i class="c-icon icon-plus-black"></i>
                            <span class="sr-only">필드 추가</span>
                          </button>
                          <!-- D: 유효성 검사 -->
                          <span
                            v-show="
                              Utils.isNotBlank(validateMessages.acptrMblTel)
                            "
                            class="input-valid"
                          >
                            {{ validateMessages.acptrMblTel }}
                          </span>
                        </div>
                        <!-- D: 삭제 케이스 -->
                        <!-- D: 유효성 검사 실패시 is-danger 클래스 추가 -->
                        <div
                          v-for="(telno, index) in form.extMblTelnos"
                          :key="index"
                          class="c-form-field type-phone"
                        >
                          <div class="c-select">
                            <select v-model="telno.telno1">
                              <option value="">선택</option>
                              <option
                                v-for="number in mobileExcNumbers"
                                :key="number"
                                :value="number"
                              >
                                {{ number }}
                              </option>
                            </select>
                          </div>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 중간 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="telno.telno2"
                            />
                          </label>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 뒷 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="telno.telno3"
                            />
                          </label>
                          <!-- D: 삭제버튼 icon만 다름 -->
                          <button
                            type="button"
                            class="c-button type-line-black type-small type-icon"
                            @click="removeExtMblTelNo(index)"
                          >
                            <i class="c-icon icon-medium-x2"></i>
                            <span class="sr-only">필드 삭제</span>
                          </button>
                          <!-- D: 유효성 검사 -->
                          <!-- <span class="input-valid"> </span> -->
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" class="vct only-pc">
                        <div class="label">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          주소
                        </div>
                      </th>
                      <td>
                        <div class="label only-mo">
                          <span class="c-required">
                            <span class="sr-only">필수</span>
                          </span>
                          주소
                        </div>
                        <div
                          class="c-form-field"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.roadNmBscAddr
                            ),
                          }"
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              maxlength="10"
                              title="우편번호"
                              readonly
                              v-model="form.zip"
                            />
                          </label>
                          <button
                            type="button"
                            class="c-button type-line-black type-small"
                            @click="openKakaoPostcode"
                          >
                            <span class="fw-nr">우편번호 찾기</span>
                          </button>
                        </div>
                        <div
                          class="c-form-field"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.roadNmBscAddr
                            ),
                          }"
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="주소"
                              readonly
                              v-model="form.roadNmBscAddr"
                            />
                          </label>
                          <span
                            v-show="
                              Utils.isNotBlank(validateMessages.roadNmBscAddr)
                            "
                            class="input-valid"
                          >
                            {{ validateMessages.roadNmBscAddr }}
                          </span>
                        </div>
                        <div
                          class="c-form-field"
                          :class="{
                            'is-danger': Utils.isNotBlank(
                              validateMessages.roadNmDtlAddr
                            ),
                          }"
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="상세 주소"
                              maxlength="100"
                              v-model="form.roadNmDtlAddr"
                            />
                          </label>
                          <span
                            v-show="
                              Utils.isNotBlank(validateMessages.roadNmDtlAddr)
                            "
                            class="input-valid"
                          >
                            {{ validateMessages.roadNmDtlAddr }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="dialog-footer  dialog-footer-delivery">
                <div class="c-btn-area">
                  <button
                    type="button"
                    class="c-button type-secondary"
                    @click="() => emits('close')"
                  >
                    <span>취소</span>
                  </button>
                  <button type="button" class="c-button type-primary" @click="submit">
                    <span>저장</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import {
  onMounted,
  defineEmits,
  ref,
  computed,
  inject,
  defineProps,
} from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";
import { api } from "@/plugins/api";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const url = inject("url_prefix");

const props = defineProps({
  address: {
    type: Object,
    default: () => null,
  },
});

const emits = defineEmits(["close", "updated"]);

// 유선 국번 리스트
const wiredExcNumbers = [
  "02",
  "031",
  "032",
  "033",
  "041",
  "042",
  "043",
  "044",
  "051",
  "052",
  "053",
  "054",
  "055",
  "061",
  "062",
  "063",
  "064",
  "070"
];

// 휴대폰 국번 리스트
const mobileExcNumbers = ["010", "011", "016", "017", "018", "019", "0502", "0503", "0504", "0508"];

const form = ref({});
const validateMessages = ref({});

onMounted(() => {
  if (!isCreateMode.value) {
    form.value = {
      dlvdesNm: props.address.dlvdesNm, // 주소지 별칭
      acptrNm: props.address.acptrNm, // 받는분
      acptrWrdTelno1: props.address.acptrWrdTelno
        ? props.address.acptrWrdTelno.split("-")[0]
        : "", // 유선전화번호1
      acptrWrdTelno2: props.address.acptrWrdTelno
        ? props.address.acptrWrdTelno.split("-")[1]
        : "", // 유선전화번호1
      acptrWrdTelno3: props.address.acptrWrdTelno
        ? props.address.acptrWrdTelno.split("-")[2]
        : "", // 유선전화번호1
      acptrMblTelno1: props.address.acptrMblTelno
        ? props.address.acptrMblTelno.split("-")[0]
        : "", // 휴대폰번호1
      acptrMblTelno2: props.address.acptrMblTelno
        ? props.address.acptrMblTelno.split("-")[1]
        : "", // 휴대폰번호2
      acptrMblTelno3: props.address.acptrMblTelno
        ? props.address.acptrMblTelno.split("-")[2]
        : "", // 휴대폰번호3
      zip: props.address.zip, // 우편번호
      ozip: props.address.ozip, // 구우편번호
      roadNmBscAddr: props.address.roadNmBscAddr, // 도로명기본주소
      roadNmDtlAddr: props.address.roadNmDtlAddr, // 도로명상세주소
      lotnoBscAddr: props.address.lotnoBscAddr, // 지번기본주소
      lotnoDtlAddr: props.address.lotnoDtlAddr, // 지번상세주소소

      extWrdTelnos: [props.address.acptrTelno1, props.address.acptrTelno2]
        .filter(
          (item) =>
            Utils.isNotBlank(item) &&
            wiredExcNumbers.includes(item.split("-")[0])
        )
        .map((item) => {
          return {
            telno1: item.split("-")[0],
            telno2: item.split("-")[1],
            telno3: item.split("-")[2],
          };
        }), // 추가 유선전화번호
      extMblTelnos: [props.address.acptrTelno1, props.address.acptrTelno2]
        .filter(
          (item) =>
            Utils.isNotBlank(item) &&
            mobileExcNumbers.includes(item.split("-")[0])
        )
        .map((item) => {
          return {
            telno1: item.split("-")[0],
            telno2: item.split("-")[1],
            telno3: item.split("-")[2],
          };
        }), // 추가 휴대폰번호
    };
  }
});

const isCreateMode = computed(() => {
  return props.address == null ? true : false;
});

const extTelnosLength = computed(() => {
  return form.value.extWrdTelnos.length + form.value.extMblTelnos.length;
});

const initForm = () => {
  form.value = {
    dlvdesNm: "", // 주소지 별칭
    acptrNm: "", // 받는분
    acptrWrdTelno1: "", // 유선전화번호1
    acptrWrdTelno2: "", // 유선전화번호1
    acptrWrdTelno3: "", // 유선전화번호1
    acptrMblTelno1: "", // 휴대폰번호1
    acptrMblTelno2: "", // 휴대폰번호2
    acptrMblTelno3: "", // 휴대폰번호3
    zip: "", // 우편번호
    ozip: "", // 구우편번호
    roadNmBscAddr: "", // 도로명기본주소
    roadNmDtlAddr: "", // 도로명상세주소
    lotnoBscAddr: "", // 지번기본주소
    lotnoDtlAddr: "", // 지번상세주소소

    extWrdTelnos: [], // 추가 유선전화번호
    extMblTelnos: [], // 추가 휴대폰번호
  };
};
initForm();

const initValidateMessages = () => {
  validateMessages.value = {
    dlvdesNm: "",
    acptrNm: "",
    acptrWrdTel: "",
    acptrMbldTel: "",
    roadNmBscAddr: "",
    roadNmDtlAddr: "",
  };
};
initValidateMessages();

// 우편번호 검색 API를 여는 함수
const openKakaoPostcode = async () => {
  if (
    typeof window.daum === "undefined" ||
    typeof window.daum.Postcode === "undefined"
  ) {
    await cmUtil.alert("카카오 우편번호 API가 로드되지 않았습니다.");
    return;
  }

  new window.daum.Postcode({
    oncomplete: function (result) {
      form.value.zip = result.zonecode;
      form.value.ozip = "";
      form.value.roadNmBscAddr =
        result.userSelectedType === "R" // R: 도로명, J: 지번
          ? result.roadAddress
          : result.jibunAddress;
      form.value.lotnoBscAddr = result.jibunAddress;

      form.value.roadNmDtlAddr = "";
      form.value.lotnoDtlAddr = "";
    },
  }).open();
};

const addExtMblTelNo = () => {
  form.value.extMblTelnos.push({
    telno1: "",
    telno2: "",
    telno3: "",
  });
};

const removeExtMblTelNo = (index) => {
  form.value.extMblTelnos.splice(index, 1);
};

const validate = () => {
  initValidateMessages();
  if (
    Utils.isNotBlank(form.value.dlvdesNm) &&
    form.value.dlvdesNm.length > 10
  ) {
    validateMessages.value.dlvdesNm = "주소지 별칭의 최대 길이는 10입니다.";
  }

  if (Utils.isBlank(form.value.acptrNm)) {
    validateMessages.value.acptrNm = "받는 분을 입력하세요.";
  } else if (form.value.acptrNm.length > 10) {
    validateMessages.value.acptrNm = "받는 분의 최대 길이는 10입니다.";
  }

  // if (Utils.isBlank(form.value.acptrWrdTelno1)) {
  //   validateMessages.value.acptrWrdTel = "유선 전화의 국번을 선택해주세요.";
  // } else if (Utils.isBlank(form.value.acptrWrdTelno2)) {
  //   validateMessages.value.acptrWrdTel =
  //     "유선 전화의 가운데 번호를 입력하세요.";
  // } else if (Utils.isBlank(form.value.acptrWrdTelno3)) {
  //   validateMessages.value.acptrWrdTel =
  //     "유선 전화의 마지막 번호를 입력하세요.";
  // } 
  
  if (isNaN(form.value.acptrWrdTelno2)) {
    validateMessages.value.acptrWrdTel =
      "유선 전화의 가운데 번호를 숫자로만 입력하세요";
  } else if (isNaN(form.value.acptrWrdTelno3)) {
    validateMessages.value.acptrWrdTel =
      "유선 전화의 마지막 번호를 숫자로만 입력하세요";
  }

  if (Utils.isBlank(form.value.acptrMblTelno1)) {
    validateMessages.value.acptrMblTel = "휴대폰 번호의 국번을 선택해주세요.";
  } else if (Utils.isBlank(form.value.acptrMblTelno2)) {
    validateMessages.value.acptrMblTel =
      "휴대폰 번호의 가운데 번호를 입력하세요.";
  } else if (Utils.isBlank(form.value.acptrMblTelno3)) {
    validateMessages.value.acptrMblTel =
      "휴대폰 번호의 마지막 번호를 입력하세요.";
  } else if (isNaN(form.value.acptrMblTelno2)) {
    validateMessages.value.acptrMblTel =
      "휴대폰 번호의가운데 번호를 숫자로만 입력하세요";
  } else if (isNaN(form.value.acptrMblTelno3)) {
    validateMessages.value.acptrMblTel =
      "휴대폰 번호의마지막 번호를 숫자로만 입력하세요";
  }

  if (
    Utils.isBlank(form.value.zip) ||
    Utils.isBlank(form.value.roadNmBscAddr)
  ) {
    validateMessages.value.roadNmBscAddr = "주소를 입력하세요.";
  }

  if (Utils.isBlank(form.value.roadNmDtlAddr)) {
    validateMessages.value.roadNmDtlAddr = "상세 주소를 입력하세요.";
  }

  return (
    Object.values(validateMessages.value).filter(
      (value) => !Utils.isBlank(value)
    ).length === 0
  );
};

const submit = async () => {
  if (!validate()) {
    await cmUtil.alert("입력값이 유효하지 않습니다.");
    return;
  }

  const extTelnos = [...form.value.extWrdTelnos, ...form.value.extMblTelnos];
  const payload = {
    dlvdesNm: Utils.isNotBlank(form.value.dlvdesNm)
      ? form.value.dlvdesNm
      : form.value.acptrNm,
    acptrNm: form.value.acptrNm,
    acptrWrdTelno:
      Utils.isNotBlank(form.value.acptrWrdTelno1) &&
      Utils.isNotBlank(form.value.acptrWrdTelno2) &&
      Utils.isNotBlank(form.value.acptrWrdTelno3)
        ? form.value.acptrWrdTelno1 +
          "-" +
          form.value.acptrWrdTelno2 +
          "-" +
          form.value.acptrWrdTelno3
        : "",
    acptrMblTelno:
      Utils.isNotBlank(form.value.acptrMblTelno1) &&
      Utils.isNotBlank(form.value.acptrMblTelno2) &&
      Utils.isNotBlank(form.value.acptrMblTelno3)
        ? form.value.acptrMblTelno1 +
          "-" +
          form.value.acptrMblTelno2 +
          "-" +
          form.value.acptrMblTelno3
        : "",
    acptrTelno1:
      extTelnos.length >= 1 &&
      Utils.isNotBlank(extTelnos[0].telno1) &&
      Utils.isNotBlank(extTelnos[0].telno2) &&
      Utils.isNotBlank(extTelnos[0].telno3)
        ? extTelnos[0].telno1 +
          "-" +
          extTelnos[0].telno2 +
          "-" +
          extTelnos[0].telno3
        : "",
    acptrTelno2:
      extTelnos.length >= 2 &&
      Utils.isNotBlank(extTelnos[1].telno1) &&
      Utils.isNotBlank(extTelnos[1].telno2) &&
      Utils.isNotBlank(extTelnos[1].telno3)
        ? extTelnos[1].telno1 +
          "-" +
          extTelnos[1].telno2 +
          "-" +
          extTelnos[1].telno3
        : "",
    zip: form.value.zip,
    roadNmBscAddr: form.value.roadNmBscAddr,
    roadNmDtlAddr: form.value.roadNmDtlAddr,
    ozip: form.value.ozip,
    lotnoBscAddr: form.value.lotnoBscAddr,
    lotnoDtlAddr: form.value.lotnoDtlAddr,
  };

  if (isCreateMode.value) {
    const res = await api.post(
      `${url}/agency/delivery/address/create`,
      payload
    );

    const { resultCode } = res;
    if (resultCode !== 200) {
      // alert(`errror : resultCode:${resultCode}, message:${message} `);
      return;
    }

    await cmUtil.alert("새 배송지가 저장되었습니다.");
  } else {
    const res = await api.post(
      `${url}/agency/delivery/address/${props.address.dlvdesSn}/modify`,
      payload
    );

    const { resultCode } = res;
    if (resultCode !== 200) {
      // alert(`errror : resultCode:${resultCode}, message:${message} `);
      return;
    }

    await cmUtil.alert("배송지가 수정되었습니다.");
  }

  emits("updated");
  emits("close");
};
</script>
